import React from 'react';
import { profile } from '../mock';
import { Mail, Phone, ArrowUpRight } from 'lucide-react';

export default function Footer() {
  return (
    <footer id="contact" className="border-t border-neutral-900 bg-[#0a0a0a]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 md:py-28">
        <p className="mono text-[11px] tracking-[0.22em] text-[#ED2D5C]">// END CREDITS</p>
        <h2 className="mt-4 font-display text-white text-[48px] sm:text-[72px] md:text-[110px] leading-[0.92]">
          Let’s talk.
        </h2>
        <p className="mt-6 text-neutral-400 max-w-[560px] text-[15px] md:text-[16px] leading-relaxed">
          Available for wedding photography & videography commissions, live productions and studio work across Essex, London and the South East.
        </p>

        <div className="mt-10 flex flex-wrap gap-3">
          <a
            href={`mailto:${profile.email}`}
            className="inline-flex items-center gap-2 bg-[#ED2D5C] hover:bg-[#d12551] px-5 py-3 mono text-[11px] tracking-[0.18em] text-white transition-colors"
          >
            <Mail size={14} />
            {profile.email.toUpperCase()}
          </a>
          <a
            href={profile.phoneHref}
            className="inline-flex items-center gap-2 border border-neutral-700 hover:border-[#ED2D5C] px-5 py-3 mono text-[11px] tracking-[0.18em] text-white hover:text-[#ED2D5C] transition-colors"
          >
            <Phone size={14} />
            {profile.phone}
          </a>
          <a
            href={profile.groupHref}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 border border-neutral-700 hover:border-[#ED2D5C] px-5 py-3 mono text-[11px] tracking-[0.18em] text-white hover:text-[#ED2D5C] transition-colors"
          >
            {profile.group}
            <ArrowUpRight size={14} />
          </a>
        </div>
      </div>

      <div className="border-t border-neutral-900">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 mono text-[10px] tracking-[0.22em] text-neutral-500">
          <p>© {new Date().getFullYear()} {profile.shortName}. All rights reserved.</p>
          <p>SITE · v1.0 · BUILT WITH GRAIN — PHOTO / FILM / LIVE</p>
        </div>
      </div>
    </footer>
  );
}
